import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '../components/Auth/LoginPage.vue';
import SsoCallbackPage from '../components/Auth/SsoCallbackPage.vue';
import DashboardPage from '../components/Dashboard/DashboardPage.vue';
import DashboardHome from '../components/Dashboard/DashboardHome.vue';
import SubconEntry from '../components/Subcon/SubconEntry.vue';
import SubconUpdate from '../components/Subcon/SubconUpdate.vue';
import SpkSubconEntry from '@/components/SpkSubcon/SpkSubconEntry.vue';
import SpkSubconAuth from '@/components/SpkSubcon/SpkSubconAuth.vue';
import SpkSubconUpdate from '@/components/SpkSubcon/SpkSubconUpdate.vue';
import SpkSubconPrint from '@/components/SpkSubcon/SpkSubconPrint.vue';
import SpkSubconPrintPreview from '@/components/SpkSubcon/SpkSubconPrintPreview.vue';
import InvoiceEntry from '../components/Invoice/InvoiceEntry.vue';
import InvoiceUpdate from '../components/Invoice/InvoiceUpdate.vue';
import InvoicePrint from '../components/Invoice/InvoicePrint.vue';
import InvoiceReport from '@/components/Invoice/InvoiceReport.vue';
import DocumentGrTemplateEntry from '@/components/DocumentGR/TemplateEntry.vue';
import DocumentGrTemplateUpdate from '@/components/DocumentGR/TemplateUpdate.vue';
import DocumentGrTemplateReport from '@/components/DocumentGR/TemplateReport.vue';
import GoodsReceiptEntry from '@/components/GoodsReceipt/GoodsReceiptEntry.vue';
import GoodsReceiptUpdate from '@/components/GoodsReceipt/GoodsReceiptUpdate.vue';
import GoodsReceiptReport from '@/components/GoodsReceipt/GoodsReceiptReport.vue';



const routes = [
  {
    path: '/',
    redirect: () => {
      return { path: '/login' };
    },
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/sso-callback',
    name: 'SsoCallback',
    component: SsoCallbackPage,
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: DashboardPage,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'DashboardHome',
        component: DashboardHome,
      },
      {
        path: 'subcon/entry',
        name: 'SubconEntry',
        component: SubconEntry,
      },
      {
        path: 'subcon/update',
        name: 'SubconUpdate',
        component: SubconUpdate,
      },
      {
        path: 'spksubcon/entry',
        name: 'SpkSubconEntry',
        component: SpkSubconEntry,
      },
      {
        path: 'spksubcon/auth',
        name: 'SpkSubconAuth',
        component: SpkSubconAuth,
      },
      {
        path: 'spksubcon/update',
        name: 'SpkSubconUpdate',
        component: SpkSubconUpdate,
      },
      {
        path: 'spksubcon/print',
        name: 'SpkSubconPrint',
        component: SpkSubconPrint,
      },
      {
        path: 'print/spk/:id',
        name: 'spk-print-preview',
        component: SpkSubconPrintPreview,
      },
      {
        path: 'invoice/entry',
        name: 'InvoiceEntry',
        component: InvoiceEntry,
      },
      {
        path: 'invoice/update',
        name: 'InvoiceUpdate',
        component: InvoiceUpdate,
      },
      {
        path: 'invoice/report',
        name: 'InvoiceReport',
        component: InvoiceReport,
      },
      {
        path: 'invoice/print',
        name: 'InvoicePrint',
        component: InvoicePrint,
      },
      {
        path: 'document-gr/template-entry', 
        name: 'DocumentGrTemplateEntry',
        component: DocumentGrTemplateEntry, 
      },
      {
        path: 'document-gr/template-update', 
        name: 'DocumentGrTemplateUpdate',
        component: DocumentGrTemplateUpdate, 
      },
      {
        path: 'document-gr/template-report', 
        name: 'DocumentGrTemplateReport',
        component: DocumentGrTemplateReport,
      },
      {
            path: 'goods-receipt/entry', 
            name: 'GoodsReceiptEntry',
            component: GoodsReceiptEntry, 
        },
        {
            path: 'goods-receipt/update', 
            name: 'GoodsReceiptUpdate',
            component: GoodsReceiptUpdate, 
        },
        {
            path: 'goods-receipt/report', 
            name: 'GoodsReceiptReport',
            component: GoodsReceiptReport,
        },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token');

  if (to.meta.requiresAuth && !isAuthenticated && to.path !== '/login') {
    next('/login');
  } else {
    next();
  }
});

export default router;